"use client"
import React, { useState, useEffect, useCallback } from "react";

import AlertInstance from "@/components/shared/AlertInstance";

import "@/components/shared/FlashMessages.css";
import { ToastContainer, Toast } from "react-bootstrap";
import ToastContent from "@/components/shared/ToastContent";
import { useMediaQuery } from "react-responsive";

const FlashMessages = ({}) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });
  const [messages, setMessages] = useState([]);
  const [alert, setAlert] = useState(null);

  const clearMessages = useCallback(
    evt => {
      setMessages([]);
    },
    [setMessages]
  );

  useEffect(() => {
    if (messages && messages.length > 0) {
      document.body.addEventListener("click", clearMessages, true);
    } else {
      document.body.removeEventListener("click", clearMessages, true);
    }

    return () =>
      document.body.removeEventListener("click", clearMessages, true);
  }, [messages, clearMessages]);

  const alertModal = messageObj => {
    setAlert(messageObj);
  };

  const addMessage = message => {
    var newMessages = [...messages];
    newMessages.push(message);
    setMessages(newMessages);
  };

  const removeMessage = message => {
    var newMessages = [...messages];
    const index = newMessages.indexOf(message);
    if (index > -1) {
      newMessages.splice(index, 1);
    }
    setMessages(newMessages);
  };

  const root = typeof window !== 'undefined' ? window : global;

  root.flash_messages = {
    alertModal,
    addMessage,
    clearMessages,
    removeMessage,
    setMessages,
    setAlert
  };

  const alerts = messages.map((message, index) => (
    <Toast key={`toast-${index}`} delay={3000} autohide>
      <Toast.Body>
        <ToastContent
          key={message.id}
          message={message}
          showActivity={message.showActivity}
          onClose={() => removeMessage(message)}
        />
      </Toast.Body>
    </Toast>
  ));

  return (
    <>
      {alert && (
        <AlertInstance
          show={true}
          onClose={() => {
            setAlert(null);
          }}
          heading={alert ? alert.heading : ""}
          textContent={alert ? alert.textContent : null}
          footerContent={alert ? alert.footerContent : null}
        />
      )}
      <div className="flash-messages">
        <ToastContainer position={isSm ? "top-center" : "bottom-start"}>
          {alerts}
        </ToastContainer>
      </div>
    </>
  );
};

export default FlashMessages;
